import UPSidePanel from './UPSidePanel';
import UPSidePanelSection from './UPSidePanelSection';

export { UPSidePanelSection };

export default UPSidePanel;
